import { useQuery } from '@tanstack/react-query'

import { billingApi } from '@/lib/api/billing'

/**
 * The account's payment order history, newest first.
 */
export function usePaymentHistory(limit = 50, offset = 0) {
  return useQuery({
    queryKey: ['billing', 'payments', 'history', limit, offset],
    queryFn: () => billingApi.payments(limit, offset),
    staleTime: 30_000,
    retry: false,
  })
}
